import { useLayoutEffect, useState } from "react"
import agreeStyle from "./agree.module.css"

import { Person, Transfer, Promotion } from "./text"


export default function Agree(props) {

    const set = props['set']
    const name = props['name']
    const required = props['required']
    const error = props['error']

    const [value, Set_value] = useState('')
    const [view, Set_view] = useState(false)

    useLayoutEffect(() => {
        const agree_content = document.getElementById(`agree_${set}_content`)
        if(view) {
            agree_content.style.height = "300px"
        }
        else {
            agree_content.style.height = "0px"
        }
    }, [view])

    return(
        <>
            <div className={agreeStyle['agreeWrap']}>
                <input
                    type="text"
                    category="field"
                    name={name}
                    required={required === true ? true : false}
                    style={{
                        display: "none"
                    }}
                    readOnly={true}
                    value={value}
                    error={error}
                ></input>

                <label className={agreeStyle['agree']}>
                    <input
                        type="checkbox"
                        name={`agree_${set}`}
                        required={required === true ? true : false}
                        onClick={(e) => {
                            if(e.currentTarget.checked) {
                                Set_value('1')
                            }
                            else {
                                Set_value('')
                            }
                        }}
                    ></input>
                    <div className={agreeStyle['checkbox']}>
                        <div className={agreeStyle['mark']}></div>
                    </div>
                    {set === 'person' &&
                    <>
                        <span className={agreeStyle['text']}>개인정보 수집 및 이용 동의</span>
                        <span className={agreeStyle['sub']}>(필수)</span>
                    </>
                    }
                    {set === 'transfer' &&
                    <>
                        <span className={agreeStyle['text']}>개인정보 제3자 이전 동의</span>
                        <span className={agreeStyle['sub']}>(필수)</span>
                    </>
                    }
                    {set === 'promotion' &&
                    <>
                        <span className={agreeStyle['text']}>프로모션 정보 수신 동의</span>
                        <span className={agreeStyle['sub']}>(선택)</span>
                    </>
                    }
                </label>

                <div
                    className={agreeStyle['viewButton']}
                    onClick={() => Set_view(!view)}
                >{view ? '닫기' : '보기'}</div>
            </div>

            <div
                id={`agree_${set}_content`}
                className={agreeStyle['content']}
            >
                {set === 'person' &&
                    <Person></Person>
                }
                {set === 'transfer' &&
                    <Transfer></Transfer>
                }
                {set === 'promotion' &&
                    <Promotion></Promotion>
                }
            </div>
        </>
    )
}